<div class="container-fluid px-0">
  <div class="row mx-0 pt-3">
    <div class="col-md-6 col-xl-3 pe-3 ps-0">
      <div class="">
        <app-multiselect-dropdown
          [listLabel]="'RoHS'"
          [list]="getAllDropdown?.roHSList"
          [checkedList]="filterCheckList?.rohs_CheckList"
          (inputValueEmit)="inputValueEmit($event)"
          >
        </app-multiselect-dropdown>
      </div>
      <div class="py-4">
        <app-dropdown
          [selectLabel]="'REACH'"
          [data]="getAllDropdown?.reachList"
          [selectValue]="formModel?.complianceExportModel?.reachId"
          (selectValueEmit)="formModel.complianceExportModel.reachId = $event"
          [required]="false"
        >
        </app-dropdown>
      </div>
      <div class="pb-4">
        <app-dropdown
          [selectLabel]="'MSL'"
          [data]="getAllDropdown?.mslList"
          [selectValue]="formModel?.complianceExportModel?.mslId"
          (selectValueEmit)="formModel.complianceExportModel.mslId = $event"
          [required]="false"
        >
        </app-dropdown>
      </div>
      <div class="pb-4 pb-md-0">
        <app-multiselect-dropdown
          [listLabel]="'COO'"
          [list]="getAllDropdown?.countryList"
          [checkedList]="filterCheckList?.coo_CheckList"
          (inputValueEmit)="inputValueCOOEmit($event)"
        >
        </app-multiselect-dropdown>
      </div>
    </div>
    <div class="col-md-6 col-lg-6 col-xl-3 order-lg-2 pt-lg-4 order-md-2 order-xl-1 pt-md-4 pt-xl-0 ps-0 pe-3 px-lg-3">
      <div class="">
        <app-input 
          [inputLabel]="'NSN'" 
          [inputType]="'text'" 
          [inputValue]="formModel?.complianceExportModel?.nsn"
          (inputValueEmit)="formModel.complianceExportModel.nsn =$event;"
          (parentFun)="onKeydown($event, '#description')"
        >
        </app-input>
      </div>
      <div class="py-4">
        <app-input 
          [inputLabel]="'HTS'" 
          [inputType]="'text'" 
          [inputValue]="formModel?.complianceExportModel?.hts"
          (inputValueEmit)="formModel.complianceExportModel.hts =$event;"
          (parentFun)="onKeydown($event, '#description')"
        >
        </app-input>
      </div>
      <div class="pb-4">
        <app-input 
          [inputLabel]="'Sched B'" 
          [inputType]="'text'" 
          [inputValue]="formModel?.complianceExportModel?.schedB"
          (inputValueEmit)="formModel.complianceExportModel.schedB =$event;"
          (parentFun)="onKeydown($event, '#description')"
        >
        </app-input>
      </div>
      <div class="pb-4 pb-md-0">
        <app-input 
          [inputLabel]="'ECCN'" 
          [inputType]="'text'" 
          [inputValue]="formModel?.complianceExportModel?.eccn"
          (inputValueEmit)="formModel.complianceExportModel.eccn =$event;"
          (parentFun)="onKeydown($event, '#description')"
        >
        </app-input>
      </div>
    </div>
    <div class="col-md-6 col-lg-6 col-xl-3 order-md-1 order-lg-1 ps-0 ps-md-3 pe-3 pe-md-0">
      <div class="">
        <app-dropdown
          [selectLabel]="enumFilterLabel?.CATEGORY_GROUP"
          [data]="getAllDropdown?.categoryGroupList"
          [selectValue]="formModel?.complianceExportModel?.categoryGroupId"
          (selectValueEmit)="formModel.complianceExportModel.categoryGroupId = $event;onChangedValue($event,enumFilterLabel?.CATEGORY_GROUP)"
          [required]="false"
        >
        </app-dropdown>
      </div>
      <div class="py-4">
        <app-dropdown
          [selectLabel]="enumFilterLabel?.PARENT_CATEGORY"
          [data]="getAllDropdown?.parentCategoryGroupList"
          [selectValue]="formModel?.complianceExportModel?.parentCategoryId"
          (selectValueEmit)="formModel.complianceExportModel.parentCategoryId = $event;onChangedValue($event,enumFilterLabel?.PARENT_CATEGORY)"
          [required]="false"
          [disabled]="!formModel?.complianceExportModel?.categoryGroupId"
      >
        </app-dropdown>
      </div>
    <div class="pb-4">
      <app-dropdown
      [selectLabel]="enumFilterLabel?.CATEGORY"
      [data]="getAllDropdown?.inventoryCategoryList"
      [selectValue]="formModel?.complianceExportModel?.categoryId"
      (selectValueEmit)="formModel.complianceExportModel.categoryId = $event;onChangedValue($event,enumFilterLabel?.CATEGORY)"
      [required]="false"
      [disabled]="!formModel?.complianceExportModel?.parentCategoryId"
    >
    </app-dropdown>
  </div>
  <div class="">
    <app-dropdown
    [selectLabel]="enumFilterLabel?.SUB_CATEGORY"
    [data]="getAllDropdown?.subCategoryList"
    [selectValue]="formModel?.complianceExportModel?.subCategoryId"
    (selectValueEmit)="formModel.complianceExportModel.subCategoryId = $event"
    [required]="false"
    [disabled]="!formModel?.complianceExportModel?.categoryId"
  >
  </app-dropdown>
</div>
      </div>
        <div class="col-md-6 col-lg-6 col-xl-3 order-lg-2 pt-lg-4 order-xl-1 order-md-2 pt-4 pt-xl-0 ps-4 pe-0">
            <div class="d-flex justify-content-between px-0">
                <label class="secondary-text text-light-info" for="">Tags:</label>
                <div (click)="clearDetails()" class="hand d-flex align-items-center">
                    <!-- <app-svg-icon 
                        class=""
                        [src]="'./assets/SVGIcons/Clearicon.svg'"  
                        class="h-33px">
                    </app-svg-icon> -->
                    <app-svg
                     class="h-33px"
                    iconType="Clear" >                        
                   </app-svg>
                    <span class="ps-2 clear-color font-14 pe-1">Clear</span>
                </div>
            </div>
            <div  class="wrapper">
            <div class="row mx-0">
                <div  class="col-12 mt-2 d-flex flex-wrap lable-div px-0">
                    <app-button
                      *ngFor="let tags of getAllDropdown?.partTagsList; let i = index"
                      [ngClass]="tags.selectedTags ? 'selected' : ''"
                      [buttonType]="'button'"
                      [button_2]="true"
                      [spanClass]="''"
                      [buttonClass]="'button-lable-primary mx-0 ps-2 text-center primary-text btn-hover'"
                      [buttonLable]="tags.name"
                      (click)="selectAccountTagsId(tags, i)"
                    >
                    </app-button>
                    <div class="d-flex justify-content-center text-light-info font-13"
                  *ngIf="getAllDropdown?.partTagsList?.length == 0">No records available</div>
                  </div>
            </div>
           </div>
        </div>
    </div>
</div>